export default "__VITE_ASSET__6cadc1b7__"